(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  let contentReady = false;
  const ready = new EventTarget();
  function allowAnimation() {
    setTimeout(() => {
      const start = () => {
        contentReady = true;
        ready.dispatchEvent(new Event('ready'));
      };
      if ('requestIdleCallback' in window) window.requestIdleCallback(start, { timeout: 3000 });
      else start();
    }, 2500);
  }
  if (document.readyState === 'complete') allowAnimation();
  else window.addEventListener('load', allowAnimation, { once: true });
  function setup(root = document) {
    root.querySelectorAll('[data-logo-animation]').forEach(picture => {
      if (picture.dataset.ready) return;
      picture.dataset.ready = 'true';
      const heading = picture.closest('.header__heading') || picture;
      let visible = true;
      function update() {
        const playing = contentReady && !reduced.matches && !connection?.saveData && visible && !document.hidden;
        picture.querySelectorAll('[data-still]').forEach(node => {
          const value = playing ? node.dataset.motion : node.dataset.still;
          const attr = node.tagName === 'SOURCE' ? 'srcset' : 'src';
          if (node.getAttribute(attr) !== value) node.setAttribute(attr, value);
        });
      }
      reduced.addEventListener('change', update);
      ready.addEventListener('ready', update, { once: true });
      connection?.addEventListener('change', update);
      document.addEventListener('visibilitychange', update);
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); }).observe(heading);
      update();
    });
  }
  setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
})();
